import React from 'react';
import { toast } from 'react-hot-toast';

export const copyToClipboard = (content, e) => {
  // If an event is provided, prevent default and stop propagation
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  
  if (content && content.trim() !== '') {
    // Copy to clipboard
    return navigator.clipboard.writeText(content)
      .then(() => {
        // Truncate long content in the toast message
        const displayContent = content.length > 20 
          ? content.substring(0, 20) + '...' 
          : content;
        
        toast.success(`Copied:\n${displayContent}`);
        return content; // Return the copied content for chaining
      })
      .catch((error) => {
        console.error('Failed to copy:', error);
        toast.error('Failed to copy to clipboard');
        throw error; // Re-throw for error handling
      });
  }
  
  return Promise.resolve(null); // Return resolved promise with null if no content
}


// --- STYLE COPY FUNCTION ---
// export const handleCopyStyle = (selectedNode, selectedEdge, setCopiedStyle) => {
//   if (selectedNode && selectedNode.data && selectedNode.data.style) {
//     setCopiedStyle({ type: 'node', style: { ...selectedNode.data.style } });
//     toast.success(`Copied Node Style}`);
//   } else if (selectedEdge) {
//     const edgeStyleAttributes = {
//       style: selectedEdge.style ? { ...selectedEdge.style } : undefined,
//       markerEnd: selectedEdge.markerEnd ? { ...selectedEdge.markerEnd } : undefined,
//       animated: selectedEdge.animated,
//     };
//     setCopiedStyle({ type: 'edge', style: edgeStyleAttributes });
//     toast.success(`Copied Edge Style`);
//   } else {
//     setCopiedStyle(null);
//   }
// };
export const handleCopyStyle = (selectedNode, selectedEdge, setCopiedStyle, newNodeSettings, newEdgeSettings) => {
  if (selectedNode && newNodeSettings && newNodeSettings.style) {
    setCopiedStyle({
      type: 'node',
      style: { ...newNodeSettings.style },
      descFontColor: newNodeSettings.descFontColor,
      descFontSize: newNodeSettings.descFontSize
    });
    console.log("{ type: 'node', style: { ...newNodeSettings.style } }", { type: 'node', style: { ...newNodeSettings.style } });
    console.log("{ type: 'node', style: { ...selectedNode.style } }", { type: 'node', style: { ...selectedNode } });
    
    toast.success(`Copied Node Style`);
  } else if (selectedEdge && newEdgeSettings) {
    const edgeStyleAttributes = {
      style: newEdgeSettings.style ? { ...newEdgeSettings.style } : undefined,
      markerEnd: newEdgeSettings.markerEnd ? { ...newEdgeSettings.markerEnd } : undefined,
      animated: newEdgeSettings.animated,
    };
    setCopiedStyle({ type: 'edge', style: edgeStyleAttributes });
    toast.success(`Copied Edge Style`);
  } else {
    setCopiedStyle(null);
  }
};


// --- STYLE PASTE FUNCTIONS ---

// Paste Node Style (either 'color' or 'full')
// export const handlePasteNodeStyle = (selectedNode, copiedStyle, onUpdateNode, pasteType) => { // pasteType can be 'color' or 'full'
//   if (!selectedNode || !copiedStyle || copiedStyle.type !== 'node' || !copiedStyle.style) {
//     // console.log('Cannot paste node style: Ensure a node is selected and a node style has been copied.');
//     return;
//   }

//   let newStyleProperties;
//   if (pasteType === 'color') {
//     const { backgroundColor, borderColor } = copiedStyle.style;
//     newStyleProperties = {
//       ...(backgroundColor !== undefined && { backgroundColor }),
//       ...(borderColor !== undefined && { borderColor }),
//     };
//   } else if (pasteType === 'style') {
//     newStyleProperties = { ...copiedStyle.style };
//   } else {
//     // console.warn('Invalid pasteType for handlePasteNode.');
//     return;
//   }

//   const updatedNodeData = {
//     ...selectedNode.data,
//     style: {
//       ...selectedNode.data.style, // Preserve existing styles
//       ...newStyleProperties,      // Apply new/updated style properties
//     },
//   };

//   onUpdateNode({ id: selectedNode.id, data: updatedNodeData });
//   toast.success(`Pasted Node "${pasteType}"`);
//   // console.log(`Pasted Node ${pasteType} style to:`, selectedNode.id);
// };
export const handlePasteNodeStyle = (selectedNode, copiedStyle, onUpdateNode, pasteType, setNewNodeSettings) => {
  if (!selectedNode || !copiedStyle || copiedStyle.type !== 'node') return;

  let updatedNodeData;
  if (pasteType === 'color') {
    const { backgroundColor, borderColor, color } = copiedStyle.style || {};
    updatedNodeData = {
      ...selectedNode.data,
      style: {
        ...selectedNode.data.style,
        ...(backgroundColor !== undefined && { backgroundColor }),
        ...(borderColor !== undefined && { borderColor }),
        ...(color !== undefined && { color }),
      },
      ...(copiedStyle.descFontColor !== undefined && { descFontColor: copiedStyle.descFontColor }),
    };
  } else if (pasteType === 'style') {
    updatedNodeData = {
      ...selectedNode.data,
      style: { ...selectedNode.data.style, ...copiedStyle.style },
      ...(copiedStyle.descFontColor !== undefined && { descFontColor: copiedStyle.descFontColor }),
      ...(copiedStyle.descFontSize !== undefined && { descFontSize: copiedStyle.descFontSize }),
    };
  } else {
    return;
  }

  onUpdateNode({ id: selectedNode.id, data: updatedNodeData });
  if (setNewNodeSettings) {
    setNewNodeSettings(updatedNodeData);
  }
  toast.success(`Pasted Node "${pasteType}"`);
};

// Paste Edge Style (remains separate as its structure is different)
// export const handlePasteEdgeStyle = (selectedEdge, copiedStyle, onUpdateEdge) => {
//   if (!selectedEdge || !copiedStyle || copiedStyle.type !== 'edge' || !copiedStyle.style) {
//     // console.log('Cannot paste edge style: Ensure an edge is selected and an edge style has been copied.');
//     return;
//   }
//   const { style, markerEnd, animated } = copiedStyle.style;

//   const updatedEdge = {
//     ...selectedEdge,
//     ...(style && { style: { ...style } }),
//     ...(markerEnd && { markerEnd: { ...markerEnd } }),
//     ...(animated !== undefined && { animated }),
//   };
//   onUpdateEdge(updatedEdge);
//   toast.success(`Pasted Edge Style`);
//   // console.log('Pasted Edge Style to:', selectedEdge.id);
// };
export const handlePasteEdgeStyle = (selectedEdge, copiedStyle, onUpdateEdge, setNewEdgeSettings) => {
  if (!selectedEdge || !copiedStyle || copiedStyle.type !== 'edge' || !copiedStyle.style) {
    return;
  }
  const { style, markerEnd, animated } = copiedStyle.style;

  const updatedEdge = {
    ...selectedEdge,
    ...(style && { style: { ...style } }),
    ...(markerEnd && { markerEnd: { ...markerEnd } }),
    ...(animated !== undefined && { animated }),
  };
  
  onUpdateEdge(updatedEdge);
  
  // Update local state if setter provided
  if (setNewEdgeSettings) {
    setNewEdgeSettings(updatedEdge);
  }
  
  toast.success(`Pasted Edge Style`);
};
